<template>
  <v-combobox
      :filled="!!filled"
      :items="$autocompletion.get('domains')"
      :prepend-icon="$vuetify.breakpoint.smAndUp ? 'mdi-web' : ''"
      :search-input.sync="currentValue"
      :menu-props="{ auto: true, overflowY: true, disableKeys: true }"
      :label="label || $t('label')"
      :hint="hint || $t('hint')"
      :rules="rules"
      hide-no-data
      :hide-details="!!hideDetails"
      @keyup.enter.prevent="$emit('enter')"
  >
    <template v-slot:append>
      <v-chip label outlined color="blue darken-2" v-if="isValid && isNew" small>{{ $t('new') }}</v-chip>
    </template>
    <template v-slot:item="{ index, item }">
      <v-btn small icon @click.stop="$autocompletion.remove('domains', item)" class="mr-2">
        <v-icon small>mdi-delete</v-icon>
      </v-btn>
      {{ item }}
    </template>
  </v-combobox>
</template>

<script>
const isValidDomain = require('is-valid-domain')

export default {
  name: 'WebsiteSelect',
  props: ['value', 'label', 'hint', 'filled', 'hideDetails', 'showNew'],
  data () {
    return {
      currentValue: this.value,
      rules: [
        () => this.isValid || this.$t('required'),
      ]
    }
  },
  watch: {
    currentValue () {
      this.sanitize()
      this.$emit('update:value', this.currentValue)
    },
    value (value) {
      this.currentValue = value
    }
  },
  computed: {
    isValid () {
      if (this.currentValue) {
        return isValidDomain(this.currentValue)
      } else {
        return false
      }
    },
    isNew () {
      if (this.showNew) {
        if (this.currentValue) {
          return !this.$autocompletion.get('domains').includes(this.currentValue)
        }
      }

      return false
    }
  },
  methods: {
    sanitize () {
      if (this.currentValue) {
        this.currentValue = this.$models.Input.sanitizeWebsiteDomain(this.currentValue)
      }
    }
  }
}
</script>

<i18n>
{
	"en": {
		"hint": "Enter or select the domain name of your site.",
		"label": "Website",
		"new": "New",
		"required": "A valid website is required."
	},
	"es": {
		"hint": "Ingrese o seleccione el nombre de dominio de su sitio.",
		"label": "Sitio web",
		"new": "Nuevo",
		"required": "Se requiere un sitio web válido."
	},
	"fr": {
		"hint": "Saisissez ou selectionnez le nom de domaine de votre site.",
		"label": "Site Web",
		"new": "Nouveau",
		"required": "Un site web valide est requis."
	},
	"it": {
		"hint": "Inserisci o seleziona il nome di dominio del tuo sito.",
		"label": "Sito web",
		"new": "Nuovo",
		"required": "È richiesto un sito web valido."
	},
	"pt": {
		"hint": "Introduza ou selecione o nome de domínio do seu site.",
		"label": "Site",
		"new": "Novo",
		"required": "É necessário um site válido."
	},
	"pl": {
		"hint": "Wpisz lub wybierz nazwę domeny swojej strony.",
		"label": "Strona internetowa",
		"new": "Nowe",
		"required": "Wymagana jest prawidłowa strona internetowa."
	}
}
</i18n>